export default "__VITE_ASSET__b4717d11__"